import UpdateBar from '@/pages/home/components/UpdateBar';
import SiteHeader from '@/pages/home/components/SiteHeader';
import HeroCover from '@/pages/home/components/HeroCover';
import EntryTabs from '@/pages/home/components/EntryTabs';
import MixedGrid from '@/pages/home/components/MixedGrid';
import MethodSteps from '@/pages/home/components/MethodSteps';
import MatchCompare from '@/pages/home/components/MatchCompare';
import ReflectionFeature from '@/pages/home/components/ReflectionFeature';
import FaqSection from '@/pages/home/components/FaqSection';
import SiteFooter from '@/pages/home/components/SiteFooter';

function CtaBand() {
  return (
    <section className="w-full bg-background-100 border-y border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="rounded-lg bg-primary-500 px-6 py-10 md:px-14 md:py-14 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div className="max-w-xl">
            <h3 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3 leading-snug">
              想逐帧确认细节的人，从这里开始
            </h3>
            <p className="text-sm leading-relaxed text-background-100">
              截图与对应片段并排放，翻反光、扒同款、查背景，一次对上。
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 shrink-0">
            <a
              href="#entry"
              className="flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50 text-primary-700 text-sm font-medium whitespace-nowrap hover:bg-background-100 transition-colors cursor-pointer"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-zoom-in-line"></i>
              </span>
              进入放大
            </a>
            <a
              href="#faq"
              className="flex items-center justify-center px-6 py-3 rounded-md border border-background-100/50 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              先看说明
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default function Home() {
  return (
    <div className="flex flex-col min-h-screen w-full bg-background-50">
      <UpdateBar />
      <SiteHeader />
      <main className="flex-1 w-full">
        <HeroCover />
        <EntryTabs />
        <MixedGrid />
        <MethodSteps />
        <MatchCompare />
        <ReflectionFeature />
        <CtaBand />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}